export default "__VITE_ASSET__DMBDu6zS__"